/**
 * ALIASES - Role-Based Color Mapping
 *
 * Maps primitive colors to role-based names.
 * To switch brands, change ONLY these mappings and all tokens update.
 *
 * These aliases are consumed by the PrimeNG preset's `primitive` section,
 * which then uses PrimeNG's '{reference}' syntax to resolve tokens.
 *
 * BRAND SWITCHING:
 * - Rentals (default): primary → rentalsMagenta
 * - Home:              primary → homeAquamarine
 * - Lock:              primary → lockOrange
 *
 * Token Hierarchy:
 * Primitives → Aliases (this file) → PrimeNG Preset ('{reference}' syntax)
 */

import {
  green,
  guestPurple,
  homeAquamarine,
  lockOrange,
  neutral,
  red,
  rentalsMagenta,
  rentsodyBlue,
  yellow,
} from './primitives.js';

// ============================================
// PRIMARY - Current Sub-brand Hero Color
// Currently: Rentals Magenta
// Change these to switch the primary brand
// ============================================

export const primary = { ...rentalsMagenta } as const;

// ============================================
// SECONDARY - Global Core (Rentsody Blue)
// Used for: global nav, brand inheritance
// ============================================

export const secondary = { ...rentsodyBlue } as const;

// ============================================
// SUCCESS - Green
// Used for: positive states, confirmations
// ============================================

export const success = { ...green } as const;

// ============================================
// WARNING - Yellow
// Used for: alerts, preventive states
// ============================================

export const warning = { ...yellow } as const;

// ============================================
// DANGER - Red
// Used for: errors, critical alerts, failures
// ============================================

export const danger = { ...red } as const;

// ============================================
// INFO - Neutral Blue (same as Secondary)
// Used for: informational states
// ============================================

export const info = { ...rentsodyBlue } as const;

// ============================================
// SURFACE - Neutral (same as Rentsody Blue)
// Used for: backgrounds, text, borders
// ============================================

export const surface = {
  ...neutral,
} as const;

// ============================================
// SUB-BRAND PALETTES
// Direct exports for Tailwind and component usage
// ============================================

/** Lock product palette - Orange */
export const lock = { ...lockOrange } as const;

/** Home product palette - Aquamarine */
export const home = { ...homeAquamarine } as const;

/** Guest product palette - Purple */
export const guest = { ...guestPurple } as const;

//** Rentsody palette - Blue (same as Secondary) */
export const rentsody = { ...rentsodyBlue } as const;

//** Rentals palette - Magenta (same as Primary) */
export const rentals = { ...rentalsMagenta } as const;
